{
  "version": 1,
  "asset_id": "5d9744c6-a343-40d1-9b3a-9a6ee4cfe3b3",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/5d9744c6-a343-40d1-9b3a-9a6ee4cfe3b3/mark-192.png",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/5d9744c6-a343-40d1-9b3a-9a6ee4cfe3b3/mark-192.png",
  "original_filename": "mark-192.png",
  "size": 15299,
  "content_type": "image/png",
  "created_at": "2026-07-25T02:18:15Z"
}
